import { render, staticRenderFns } from "./UserSignup.vue?vue&type=template&id=5dfa39bf&scoped=true&"
import script from "./UserSignup.vue?vue&type=script&lang=js&"
export * from "./UserSignup.vue?vue&type=script&lang=js&"
import style0 from "./UserSignup.vue?vue&type=style&index=0&id=5dfa39bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfa39bf",
  null
  
)

export default component.exports